import React from 'react';
import SlotCard from './SlotCard';

const SlotGrid = ({ slots, onSlotSelect, selectedSlot, selectedProvider, providerName }) => {
  return (
    <section className="flex-1 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header - Cinematic Style */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-xl text-white font-light tracking-wide">
              {providerName}
            </h2>
            <p className="text-xs text-gray-500 mt-1">{slots.length} jogos disponíveis</p>
          </div>
          
        </div>

        {/* Slots Grid - Cinematic Casino Lobby */}
        <div className="grid grid-cols-2 min-[480px]:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-3 lg:gap-4">
          {slots.map((slot, index) => (
            <div 
              key={slot.id} 
              className="animate-fade-in" 
              style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
            >
              <SlotCard slot={slot} onSelect={onSlotSelect} isSelected={selectedSlot?.id === slot.id} />
            </div>
          ))}
        </div>

      </div>

      {/* Animation */}
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.4s ease-out both;
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-fade-in { animation: none; }
        }
      `}</style>
    </section>
  );
};

export default SlotGrid;
